import type { Memory } from "#features/personalization/hooks/useUpdatePersonalizationForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Button, Flex, Text } from "@hopper-ui/components";
import { DeleteIcon, EditIcon } from "@hopper-ui/icons";

interface Props {
    memory: Memory;
    onDelete: () => void;
    onStartEdit: () => void;
}

export const SavedMemoryItemView = ({ memory, onDelete, onStartEdit }: Props) => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex gap="inline-xs" alignItems="center" width="100%">
            <Text
                paddingY="inset-sm"
                paddingX="inset-md"
                flexGrow={1}
                wordBreak="break-word"
                whiteSpace="pre-wrap"
                style={{ border: "1px solid transparent" }}
            >
                {memory.value}
            </Text>
            <Button
                aria-label={tShared("personalization.editMemory")}
                onPress={onStartEdit}
                variant="ghost-secondary"
                size="sm"
                flexShrink={0}
            >
                <EditIcon />
            </Button>
            <Button
                aria-label={tShared("personalization.deleteMemory")}
                onPress={onDelete}
                variant="ghost-secondary"
                size="sm"
                flexShrink={0}
            >
                <DeleteIcon />
            </Button>
        </Flex>
    );
};
